export const MODAL_TITLE = "Error";
